export default __webpack_public_path__ + "media/images/landlords_page/benefits_1-31845093ac7c4faae7603a72b24f7e5c.webp";